module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/cooking/bowl-38fab0b101b913ca8b4567d0c44e4cb4.svg";